/**
 * @generated SignedSource<<9b63514c9db6a72b777cde56c6c3a1e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paymentMethodIsPermissible_paymentMethod$data = {
  readonly shippingAddresses: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentType": "paymentMethodIsPermissible_paymentMethod";
};
export type paymentMethodIsPermissible_paymentMethod$key = {
  readonly " $data"?: paymentMethodIsPermissible_paymentMethod$data;
  readonly " $fragmentSpreads": FragmentRefs<"paymentMethodIsPermissible_paymentMethod">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paymentMethodIsPermissible_paymentMethod"
};

(node as any).hash = "fcf604810465407d6266e77569bb6437";

export default node;
